export default "__VITE_ASSET__CmNmwGsU__"